<template>
  <div v-if="summary">
    <div>
      {{ summary.testAttempts }} test attempts,
      {{ summary.completedAttempts }} completed
    </div>
    <div>{{ summary.answerCount }} questions, {{ correctPercent }} correct</div>
  </div>
  <div v-else>No attempts</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import { SfMathsLevelResultSummary } from "@/types/mathsTypes";

import calculatePercent from "@/func/format/calculatePercent";

export default defineComponent({
  props: {
    summary: {
      type: Object as PropType<SfMathsLevelResultSummary>,
      default: null,
    },
  },
  computed: {
    correctPercent() {
      return calculatePercent(
        this.summary.answerCount,
        this.summary.correctAnswers,
      );
    },
  },
});
</script>
